/*
Slides

  --length <float> | inches
  --closingMechanism <string::combobox>
  --loadWeight <float> | pounds
  --overTravel <float> | inches | default: 0
  --mountType <string::enum> | ['Side Mount', 'Under Mount']
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Slides'
const id = 'yV1YzJspH2RKr1r6ueHV'

export default {
  name,
  id,
  filters,
  headers,
  form
}
